import LanguageManager from '../language_manager/language_manager';
const config = require('../../config');
const DomUtils = require('../../util/dom_utils');
const PauseScreen = require('../pause_screen/pause_screen');
var EventEmitter = require('event-emitter');
var emitter = EventEmitter({});

const SHOW_AGE_SCREEN_TIME_MS = 3000;
let element;
let AgeAdvisor = {};

AgeAdvisor.showLoader = function() {
    if (!(element && document.body.contains(element))) {
        element = DomUtils.createElementFromString(require('./age_advisor.hbs')({}));
        document.getElementById(config.playerElementId).appendChild(element);
    }
};

AgeAdvisor.showAgeScreen = function(options, pause, resume) {
    document.getElementsByClassName('player-age-icon')[0].innerHTML = getMPAARatingByAge(options.ageRestriction);
    document.getElementsByClassName('start-text')[0].innerHTML = LanguageManager.get('age_screen').replace(/\{\{age}}/g, options.ageRestriction);

    setTimeout(function() {
        element.parentNode.removeChild(element);
        // this snippet is to test whether autoplay is blocked or not.
        // checkBrowserAutoplay(pause, resume);
        setTimeout(() => checkBrowserAutoplay(pause, resume), 500);
    }, SHOW_AGE_SCREEN_TIME_MS);
};

AgeAdvisor.clean = function() {
    DomUtils.destroyElementByType('class', 'player-modal--start');
};

function getMPAARatingByAge(age) {
    if (age >= 18) {
        return 'R';
    } else if (age >= 15) {
        return '15';
    } else if (age >= 7) {
        return 'PG';
    } else if (age >= 1) {
        return 'G';
    } else {
        return 'R';
    }
}
function checkBrowserAutoplay(pause, resume) {
    const whenPlaybackFails = doPause => err => {
        const fnDoPause = () => {
            pause();
            const pauseScreen = new PauseScreen(emitter);
            pauseScreen.hide();
            pauseScreen.showResumeLayout(resume);
            console.log(err);
            window.queued_timers.map(x => clearTimeout(x));
        }
        
        // Autoplay was prevented.
        doPause ? fnDoPause() : resume();
    };

    try {
        var promise = document.querySelector('video').play();        
        if (promise !== undefined) {
            promise.then(_ => {
                // Autoplay started!
                console.log('calling the pause/resume seq');
                pause();   
                resume();
            }).catch(err => {
                whenPlaybackFails(true)(err);
            });
        } else {
            throw 'Failed to play';
        }
    } catch (err) {
        whenPlaybackFails(false)(err);
    }
}
module.exports = AgeAdvisor;



// WEBPACK FOOTER //
// ./src/modules/age_advisor/age_advisor.js